import React from 'react';
import Typography from '@material-ui/core/Typography';
import _get from 'lodash/get';
import Box from '@material-ui/core/Box';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Link, useHistory } from 'react-router-dom';
import ArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { capitalizeFirstLetter } from 'utils/stringUtils';
import useAlgoliaLocale from 'components/useAlgoliaLocale';
import { getAlgoliaLocalizedField } from 'utils/localeUtils';
import Divider from '@material-ui/core/Divider';
import ClientExclusiveCard from '../../ClientResources/ClientExclusiveCard';

const useStyles = makeStyles(theme => ({
  container: {
    padding: '0 42px',
    marginTop: 24,
    [theme.breakpoints.down('xs')]: {
      padding: '16px 5%',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  title: {
    ...theme.typography.h7,
    fontSize: 14,
    color: '#212121',
  },
  list: {
    display: 'flex',
    padding: 0,
    paddingBottom: 12,
    margin: '0 !important',
    flexWrap: 'nowrap',
    gap: 12,
    listStyle: 'none',
    [theme.breakpoints.down('1000')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
    },
  },
  item: {
    maxWidth: 160,
    minWidth: 140,
  },
}));

export const ExclusiveResources = ({
  onLinkClick,
  searchConfig,
  data,
  onResourceClick,
  variantELocale,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const locale = useAlgoliaLocale();
  const clientDetails = useSelector(state => state.main.clientDetails);
  const title =
    _get(
      clientDetails,
      'metadata.linksTypeLabel',
      getAlgoliaLocalizedField(data, 'type', variantELocale || locale),
    ).toUpperCase() || _get(searchConfig, 'pageCopy.exclusiveLabel');

  const pageName = capitalizeFirstLetter(
    history.location.pathname.split('/')[1]?.toLowerCase(),
  );
  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <Typography className={classes.title}>{title}</Typography>
        <Box className={classes.linkContainer}>
          <Link
            to={`/client-resources${
              variantELocale ? `&lang=${variantELocale}` : ''
            }`}
            className={classes.link}
            onClick={() => onLinkClick('Resources')}
          >
            {_get(searchConfig, 'pageCopy.resourcesAll')}
            <ArrowRight />
          </Link>
        </Box>
      </Box>
      <Box component="ul" className={classes.list}>
        {data?.slice(0, 5).map(item => (
          <Box
            component="li"
            key={`${item.url}-${item.slug}`}
            className={classes.item}
          >
            <ClientExclusiveCard
              item={{ ...item, name: item.nameTitle }}
              onClick={onResourceClick}
              page={pageName}
              fromSuggestions
            />
          </Box>
        ))}
      </Box>
      <Divider />
    </Box>
  );
};
